// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ro-z","heading":"So-z"};